import type { ToolHistoryPage } from '@reach/shared-types/tool-history';
import { partnerApi, type ApiResponse } from '../../lib/api';

export const toolHistoryKeys = {
  detail: (toolId: string) => ['tool-history', toolId] as const,
};

export async function getToolHistory(toolId: string, cursor?: string): Promise<ToolHistoryPage> {
  const query = new URLSearchParams();
  if (cursor) query.set('cursor', cursor);
  const queryString = query.toString();
  const querySuffix = queryString ? `?${queryString}` : '';
  const response = await partnerApi.request<ApiResponse<ToolHistoryPage>>(
    `/partner/tool-definitions/${toolId}/history${querySuffix}`,
  );
  return response.data;
}
